"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenChildren = void 0;

var react_1 = __importDefault(require("react"));

var flattenChildren = function flattenChildren(children) {
  var childrenArray = react_1.default.Children.toArray(children);
  return childrenArray.reduce(function (flatChildren, child) {
    if (child.type === react_1.default.Fragment) {
      return flatChildren.concat((0, exports.flattenChildren)(child.props.children));
    }

    flatChildren.push(child);
    return flatChildren;
  }, []);
};

exports.flattenChildren = flattenChildren;